import React from 'react';
import { Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface LimitedAccessBannerProps {
  onReactivate: () => void;
}

export const LimitedAccessBanner: React.FC<LimitedAccessBannerProps> = ({ onReactivate }) => {
  return (
    <div 
      className="limited-access-banner rounded-lg p-4 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6 mb-6"
    >
      {/* Lock Icon */}
      <div className="flex-shrink-0">
        <div 
          className="limited-access-banner-icon w-12 h-12 sm:w-14 sm:h-14 rounded-full flex items-center justify-center"
        >
          <Lock className="w-6 h-6 sm:w-7 sm:h-7 text-white" />
        </div>
      </div>

      {/* Text Content */}
      <div className="flex-1 text-white">
        <h3 className="limited-access-banner-title mb-2">Limited Profile Access</h3>
        <p className="limited-access-banner-description opacity-95">
          Subscribe to unlock full potential features, continue learning, and access your network.
        </p>
      </div>

      {/* Reactivate Button */}
      <div className="flex-shrink-0 w-full sm:w-auto">
        <Button
          onClick={onReactivate}
          className="limited-access-banner-button text-white transition-colors"
        >
          Subscribe
        </Button>
      </div>
    </div>
  );
};

